//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.RPO.js";
import "../no/Expression.js";
let d=[[[1,"CounterboreDepth",0,"Expression",0],[1,"CounterboreDiameter",0,"Expression",0],[1,"CountersinkAngle",0,"Expression",0],[1,"CountersinkDiameter",0,"Expression",0],[1,"Depth",0,"Expression",0],[1,"Diameter",0,"Expression",0],[0,"PlacementFace",0,"ISurface",0],[0,"ThruFace",0,"ISurface",0],[1,"TipAngle",0,"Expression",0]],[[[],"GetSubtype",{R_:{subtype:''}},0,0],[["diameter","depth","tip_angle"],"GetSimpleHole",{},0,0],[["diameter","depth","tip_angle","cbore_diameter","cbore_depth"],"GetCounterboreHole",{},0,0],[["diameter","depth","tip_angle","csink_diameter","csink_angle"],"GetCountersinkHole",{},0,0],[["num_dimensions"],"GetPositioningDimensions",{R_:{positioning_dimensions:"PositioningDimension[]"}},0,0]],[]];
SPLM.Features.Hole = class extends SPLM.Features.RPO{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Hole";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Hole.Subtype = Object.freeze({
    "Simple" : "Simple", "Counterbore" : "Counterbore", "Countersink" : "Countersink"});

export default SPLM;